module.exports = __webpack_public_path__ + "img/recon.4c2f97e2.svg";